var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuienesSomosShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 120C118.209 120 120.007 118.209 119.933 116.001C119.453 101.606 116.385 87.4042 110.866 74.078C104.835 59.5189 95.9959 46.2902 84.8528 35.1472C73.7098 24.0041 60.4811 15.165 45.922 9.13443C32.5958 3.61452 18.3938 0.546623 3.99937 0.0666366C1.79146 -0.00698673 -9.65645e-08 1.79084 0 3.99998L7.62939e-06 116C7.72596e-06 118.209 1.79087 120 4.00001 120L116 120Z",
    fill: "#485637",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuienesSomosShape);
export default __webpack_public_path__ + "static/media/quienes-somos-shape.15b244d40eb82234b8be526c8193b025.svg";
export { ForwardRef as ReactComponent };